export default "__VITE_ASSET__Cm8B69bZ__"